import React, { useEffect } from 'react';

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import BenefitDescription from "../components/BenefitDescription";
import BenefitImage from "../components/BenefitImage";
import Features from "../components/Features";
import CTA from "../components/CTA";
import HowItWorks from "../components/HowItWorks";
import FAQ from "../components/FAQ";

import benefit1 from "../images/benefit-1.svg"
import benefit2 from "../images/benefit-2.svg"
import benefit3 from "../images/benefit-3.svg"

import AOS from 'aos';
import 'aos/dist/aos.css';

function IndexPage() {

  useEffect(() => {
    AOS.init({duration: 1200, delay: 200, once:false});
  })    

  return (
    <Layout>
      <SEO title="Home" />
      {/* hero section */}
      <Hero />

      {/* how it works section */}
      <HowItWorks />

      {/* benefits section */}
      <div className="container px-2 md:px-4 lg:px-8 mx-auto my-8">
        <div className="flex flex-col md:flex-row py-12 lg:py-16">
          <BenefitDescription 
            heading="Why can't I find a decent React & TailwindCSS landing page?" 
            fade="right"
            description="There are so many great resources for React templates and TailwindCSS templates, but very few that feature both, let alone templates that optimize for conversion."
          />
          <BenefitImage fade="left" imageSrc={benefit1} imageWidth="w-5/6 md:w-8/12" />
        </div>
        <div className="flex flex-col-reverse md:flex-row py-12">
          <BenefitImage fade="right" imageSrc={benefit2} imageWidth="w-5/6 md:w-9/12" />
          <BenefitDescription 
            fade="left"
            heading="The home for the best React & TailwindCSS templates" 
            description="We have designed high converting production ready landing page templates buit in React with TailwindCSS."
          />          
        </div>
        <div className="flex flex-col md:flex-row py-12 lg:py-16">
          <BenefitDescription 
            fade="right"
            heading="No compromises" 
            description="We retain the best of both worlds by creating reusable components in the spirit of React but applying Tailwind classes without any unnecessary abstraction in between."
          />
          <BenefitImage fade="left" imageSrc={benefit3} imageWidth="w-5/6 md:w-9/12" />
        </div>                
      </div> 

      {/* features section */}
      <Features />

      {/* faq section */}
      <FAQ />

      {/* call to action section */}
      <CTA />

    </Layout>
  );
}

export default IndexPage;